"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (value) {
	if (value >= 0 && value < 10) {
		return "0" + value;
	}

	return value.toString();
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/common/LeadingZero/index.js